export default __webpack_public_path__ + "static/media/bank-interest-grey.dcf59cd6.svg";